import { ISelfServiceComponente } from '../../../../Pages/Cadastro/CadSelfService';
import { useDispatch } from 'react-redux';
import { AppDispatch, useAppSelector } from '../../../../redux/store';
import { useState, useMemo } from 'react';

import LayoutHookTable from '../../../reactHookForm/LayoutTable';
import DataTable from 'react-data-table-component';
import { paginationOptions } from '../../../data/PagineteInfo';
import CustomLoader from '../../../data/customLoader';
import { ISelfServiceProduct } from '../../../../redux/features/selfService/interface';
import tableStyleDefault from './tableStyleSelfService';
import Globals from './../../../../Globals.json';

import { InputFilter } from './InputFilter';
import Loading from '../../../Loading/Loading';
import { Btn } from '../../../data/Btn';
import { ModalAPP } from './Modal';
import { ModalAtivarEmMassa } from '../../../ModalAtivarEmMassa';

import { useQueryFetchPages } from '../../../../apiQuery/useQueryFetchPages';
import { useUpdateData } from '../../../../apiQuery/useUpdateData';
import LayoutFilter from '../../../data/LayoutFilter';

export function SelfServiceComponente({ title }: ISelfServiceComponente) {
  const dispatch = useDispatch<AppDispatch>();
  const storeMe = useAppSelector(({ storeMeReducer }) => storeMeReducer.value);

  const [page, setPage] = useState(1);
  const [name, setName] = useState<string>('');
  const [category, setCategory] = useState<string>('');
  const [filter, setFilter] = useState('');
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const [loadingSelecteds, setLoadingSelecteds] = useState<boolean>(false);
  const [selectedRows, setSelectedRows] = useState<ISelfServiceProduct[]>([]);
  const [selectedProduct, setSelectedProduct] = useState<ISelfServiceProduct>();
  const [openModal, setOpenModal] = useState<boolean>(false);
  const [logo, setLogo] = useState<any>();
  const [clearSelectedRows, setClearSelectedRows] = useState(false);
  const [openBulkModal, setOpenBulkModal] = useState<boolean>(false);

  const queryKey = useMemo(
    () =>
      [
        'products',
        String(storeMe?.storeActive?.id),
        String(page),
        category,
        name,
      ].filter(Boolean), // remove undefined ou null
    [storeMe?.storeActive?.id, page, category, name]
  );

  const { mutateAsync: updateProduct } = useUpdateData(queryKey);

  const {
    data: products,
    isLoading,
    isError,
  } = useQueryFetchPages<ISelfServiceProduct>(
    queryKey,
    `${Globals.api.products}`,
    {
      page: page,
      queryParams: {
        append: 'stock_qty',
        store_id: storeMe?.storeActive?.id,
        ...(category && { 'filter[id_pdv_category]': category }),
        ...(name?.trim()?.length > 2 && {
          'filter[product_name]': name?.trim(),
        }),
      },
    }
  );

  const handleClose = () => {
    setLogo(undefined);
    setOpenModal(false);
  };

  const handleShow = (row: ISelfServiceProduct) => {
    setSelectedProduct(row);
    setOpenModal(true);
  };

  const handlePageChange = (page: number) => {
    setPage(page);
  };

  const handleToggleSelfService = async (row: ISelfServiceProduct) => {
    try {
      await updateProduct({
        endpoint: Globals.api.products,
        id: row.uuid,
        payload: {
          self_service: !row.self_service,
          id_pdv_category: row.id_pdv_category,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleToggleIsActived = async (row: ISelfServiceProduct) => {
    try {
      await updateProduct({
        endpoint: Globals.api.products,
        id: row.uuid,
        payload: {
          is_active: !row.is_active,
          id_pdv_category: row.id_pdv_category,
        },
      });
    } catch (error) {
      console.error(error);
    }
  };

  const handleRowSelected = ({
    selectedRows,
  }: {
    selectedRows: ISelfServiceProduct[];
  }) => {
    setSelectedRows(selectedRows);
  };

  const handleBulkUpdateIsActive = async () => {
    setLoadingSelecteds(true);
    try {
      await Promise.all(
        selectedRows.map((row) =>
          updateProduct({
            endpoint: Globals.api.products,
            id: row.uuid,
            payload: {
              is_active: !row.is_active,
              id_pdv_category: row.id_pdv_category,
            },
          })
        )
      );
    } catch (error) {
      //showError('Erro ao atualizar os produtos selecionados');
    } finally {
      setLoadingSelecteds(false);
      setSelectedRows([]);
      setClearSelectedRows((prev) => !prev);
    }
  };

  const handleBulkUpdateSelfService = async () => {
    setLoadingSelecteds(true);
    try {
      await Promise.all(
        selectedRows.map((row) =>
          updateProduct({
            endpoint: Globals.api.products,
            id: row.uuid,
            payload: {
              self_service: !row.self_service,
              id_pdv_category: row.id_pdv_category,
            },
          })
        )
      );
    } catch (error) {
      //showError('Erro ao atualizar os produtos selecionados');
    } finally {
      setLoadingSelecteds(false);
      setSelectedRows([]);
      setClearSelectedRows((prev) => !prev);
    }
  };

  const columns: any = [
    {
      name: 'Ativo',
      cell: (row: ISelfServiceProduct) => (
        <input
          style={{ cursor: 'pointer' }}
          type="checkbox"
          checked={row.is_active}
          onChange={() => handleToggleIsActived(row)}
        />
      ),
      width: '80px',
      center: true,
    },
    {
      name: 'Produto',
      selector: (row: ISelfServiceProduct) => row.sale_name,
      grow: 2,
    },
   {
      name: 'Categoria',
      selector: (row: ISelfServiceProduct) => 
        row.relationships?.category?.name || 'Sem categoria',
      grow: 2,
    },
    
    {
      name: 'Autoatendimento',
      cell: (row: ISelfServiceProduct) => (
        <input
          style={{ cursor: 'pointer' }}
          type="checkbox"
          checked={row.self_service}
          onChange={() => handleToggleSelfService(row)}
        />
      ),
      width: '150px',
      center: true,
    },
    {
      name: 'Imagem',
      cell: (row: ISelfServiceProduct) => (
        <img
          src={row.image || 'https://via.placeholder.com/100'}
          onClick={() => handleShow(row)}
          alt="Produto"
          style={{
            width: '80px',
            height: '60px',
            borderRadius: '8px',
            border: '1px solid #ccc',
            cursor: 'pointer',
          }}
        />
      ),
      width: '100px',
      center: true,
    },
  ];

  return (
    <>
      <ModalAPP
        show={openModal}
        handleClose={handleClose}
        selectedProduct={selectedProduct}
        logo={logo}
        setLogo={setLogo}
        currentPage={page}
        filter={filter}
        storeMe={storeMe}
        updateProduct={updateProduct}
      />

      <ModalAtivarEmMassa
        show={openBulkModal}
        onHide={() => setOpenBulkModal(false)}
      />

      <div>
        <LayoutFilter
          title={title}
          openFilter={openFilter}
          onClickOpenFilter={() => setOpenFilter(!openFilter)}
          extraActions={
            <Btn
              text="Ativar em Massa"
              type="button"
              variante="primary"
              onClick={() => setOpenBulkModal(true)}
            />
          }
        >
          <InputFilter
            openFilter={openFilter}
            name={name}
            setName={setName}
            category={category}
            setCategory={setCategory}
          />
        </LayoutFilter>

        {selectedRows.length > 0 && (
          <LayoutHookTable>
            <div style={{ display: 'flex', gap: '1rem' }}>
              <Btn
                variante="primary"
                text="Ativar/Desativar Selecionados"
                type="button"
                onClick={handleBulkUpdateIsActive}
              />
              <Btn
                variante="primary"
                text="Ativar/Desativar Autoatendimento Selecionados"
                type="button"
                onClick={handleBulkUpdateSelfService}
              />
            </div>
          </LayoutHookTable>
        )}

        <LayoutHookTable>
          <div style={{ padding: '0 1rem' }}>
            <DataTable
              columns={columns}
              data={products?.data || []}
              selectableRows
              onSelectedRowsChange={handleRowSelected}
              clearSelectedRows={clearSelectedRows}
              striped
              pagination
              paginationServer
              paginationTotalRows={products?.meta?.total}
              paginationDefaultPage={1}
              paginationPerPage={15}
              onChangePage={handlePageChange}
              customStyles={tableStyleDefault}
              paginationComponentOptions={paginationOptions}
              progressPending={isLoading}
              progressComponent={<CustomLoader />}
              noDataComponent="Nenhuma informação foi encontrada."
            />
          </div>
        </LayoutHookTable>
      </div>

      {loadingSelecteds && <Loading />}
    </>
  );
}
